import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouteReuseStrategy, RouterModule, Routes, Router, DetachedRouteHandle } from '@angular/router';
import { OopsComponent } from './oops/oops.component';
import { CheckoutCommon } from './pages/_brand-pages-base/base-controllers/checkout/checkout-common';
import { CheckoutCommonTC } from './pages/checkout-pages/checkout-commonTC';
import { WhatIsThisPage } from '../pages/what-is-this/what-is-this';
import { SafeOrderPage } from '../pages/safe-order/safe-order';
import { DestinationComponent } from './destination/destination.component';
import { UpsellDynamic } from './upsell/upsell-dynamic';
import { GdprComponent } from './gdpr/gdpr.component';
import { PageConfigDataResolver } from './resolve/page-config-data-resolve';

const US_GENERIC_MODULE_IMPORT = import('./upsells-downsells/upsells/us-generic/us-generic.module').then(m => m.USGenericModule);
// const DS_GENERIC_MODULE_IMPORT = import('./upsells-downsells/downsells/ds-generic/ds-generic.module').then(m => m.DSGenericModule);
const UPSELL_RD_MODULE_IMPORT = import('../upsellrd/upsellrd.module').then(m => m.UpsellrdModule);
const ORDER_SUCCESS_MODULE_IMPORT = import('./order-success/order-success.module').then(m => m.OrderSuccessModule);
const DOWNSELL_GENERIC_TEMPLATE_PATH = '../assets/page-configurations/downsells/DS_1-Unit-Generic.json';

const ds1 = (productName: string, unitType = 'jar', unitTypeNextUp = 'jars', configPath = DOWNSELL_GENERIC_TEMPLATE_PATH) => ({
  pageConfigPath: configPath,
  productQuantity: 1,
  productQuantityNextUp: 3,
  productUnitType: unitType,
  productUnitTypeNextUp: unitTypeNextUp,
  productName,
});

const ds3 = (productName: string, unitType = 'jars', unitTypeNextUp = 'jars', configPath = DOWNSELL_GENERIC_TEMPLATE_PATH) => ({
  pageConfigPath: configPath,
  productQuantity: 3,
  productQuantityNextUp: 6,
  productUnitType: unitType,
  productUnitTypeNextUp: unitTypeNextUp,
  productName,
});

const baseRouteConfig = {
  loadChildren: () => US_GENERIC_MODULE_IMPORT,
  resolve: { data: PageConfigDataResolver }
};


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: OopsComponent },
  { path: 'gdpr', component: GdprComponent },
  { path: 'ActivatedYou_SecureCart', component: CheckoutCommon },
  { path: 'fst/:generidUrl', component: DestinationComponent },
  { path: 'ActivatedYou_Receipt_AP', data: { animation: 'enterLeavePage' }, loadChildren: () => import('./order-success/order-success.module').then(m => m.OrderSuccessModule) },
  { path: 'upDownDyn', component: UpsellDynamic, data: { animation: 'enterLeavePage' } },
  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
  { path: 'OrderSuccess', loadChildren: () => import('./order-success/order-success.module').then(m => m.OrderSuccessModule) },
  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
  { path: 'upsellrd', loadChildren: () => import('../upsellrd/upsellrd.module').then(m => m.UpsellrdModule) },

  /* Settings explained:
  * enableCyberSource: true - Enables CyberSource payment processing integration
  * braintreeEnabled: true - Enables Braintree payment processing
  * braintreeDropInEnabled: false - Disables the Braintree Drop-in UI component
  * useNewBraintreeStyles: true - Uses updated Braintree styling
  * euSpecified: false - Indicates this is not a European Union specific configuration
  * currency: 'USD' - Sets USD as the transaction currency
  * officialCurrency: 'USD' - Sets USD as the display currency
  * currencySymbol: '$' - Sets $ as the currency symbol
  * checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC,hidePaypalButton,decorateBraintreePayPalButton' - Enables specific checkout features:
  *   - showProductBoxVariant1: Shows variant 1 of the product box
  *   - showFeatures: Shows feature highlights
  *   - isCheckoutCommonTC: Uses CheckoutCommonTC component
  *   - hidePaypalButton: Hides the PayPal payment button
  *   - decorateBraintreePayPalButton: Decorates the PayPal payment button with a placeholder cover
  */

  //PayPal NVP Button + Cybersource
  { path: 'ActivatedYou_SecureCart_241122', component: CheckoutCommonTC, data: { currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1, showFeatures, isCheckoutCommonTC' } },


  // UPSELLS
  { path: 'CTUS_3-Unit-GutStrike-MorningKick_AP_250513', data: { pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-GutStrike-MorningKick_AP_250513.json', productQuantity: 3 }, ...baseRouteConfig },
  { path: 'CTUS_6-Unit-GutStrike-MorningKick_AP_250513', data: { pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-GutStrike-MorningKick_AP_250513.json', productQuantity: 6 }, ...baseRouteConfig },


  // DOWNSELLS
  { path: 'DS_1-Unit-EmailDS_AP', data: { pageConfigPath: DOWNSELL_GENERIC_TEMPLATE_PATH, productQuantity: 1, productQuantityNextUp: 3, productUnitType: 'unit', productUnitTypeNextUp: 'units' }, ...baseRouteConfig }, //productName from SF image productAltTag
  { path: 'DS_3-Unit-EmailDS_AP', data: { pageConfigPath: DOWNSELL_GENERIC_TEMPLATE_PATH, productQuantity: 3, productQuantityNextUp: 6, productUnitType: 'units', productUnitTypeNextUp: 'units' }, ...baseRouteConfig }, //productName from SF image productAltTag

  // ROUTES DEV-54356
  // Essential Skin Food
  { path: 'US_3-Unit-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood_AP.json', productQuantity: 3, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood_AP.json', productQuantity: 6, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-EssentialSkinFood_AP', data: ds1('Essential Skin Food', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-EssentialSkinFood_AP', data: ds3('Essential Skin Food', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP.json'), ...baseRouteConfig },

  // BioCollagen Complex (Essential Skin Food funnel)
  { path: 'US_3-Unit-BioCollagenComplex-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BioCollagenComplex-EssentialSkinFood_AP.json', productQuantity: 3, productName: 'BioCollagen Complex', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-BioCollagenComplex-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BioCollagenComplex-EssentialSkinFood_AP.json', productQuantity: 6, productName: 'BioCollagen Complex', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-BioCollagenComplex_AP', data: { pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-BioCollagenComplex_AP.json', productQuantity: 1, productQuantityNextUp: 3, productUnitType: 'jar', productUnitTypeNextUp: 'jars', productName: 'BioCollagen Complex' }, ...baseRouteConfig },
  { path: 'DS_3-Unit-BioCollagenComplex_AP', data: { pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-BioCollagenComplex_AP.json', productQuantity: 3, productQuantityNextUp: 6, productUnitType: 'jars', productUnitTypeNextUp: 'jars', productName: 'BioCollagen Complex' }, ...baseRouteConfig },

  // Morning Complete (Essential Skin Food funnel)
  { path: 'US_3-Unit-MorningComplete-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete-EssentialSkinFood_AP.json', productQuantity: 3, productName: 'Morning Complete', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-MorningComplete-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete-EssentialSkinFood_AP.json', productQuantity: 6, productName: 'Morning Complete', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-MorningComplete_AP', data: ds1('Morning Complete', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MorningComplete_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-MorningComplete_AP', data: ds3('Morning Complete', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MorningComplete_AP.json'), ...baseRouteConfig },

  // Cell Advantage (Essential Skin Food funnel)
  { path: 'US_3-Unit-CellAdvantage-ESF_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-CellAdvantage-ESF_AP.json', productQuantity: 3, productName: 'Cell Advantage', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-CellAdvantage-ESF_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-CellAdvantage-ESF_AP.json', productQuantity: 6, productName: 'Cell Advantage', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-CellAdvantage_AP', data: ds1('Cell Advantage', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-CellAdvantage_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-CellAdvantage_AP', data: ds3('Cell Advantage', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-CellAdvantage_AP.json'), ...baseRouteConfig },

  // Morning Complete 240708
  { path: 'US_3-Unit-MorningComplete_AP_240708', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete_AP_240708.json', productQuantity: 3, productName: 'Morning Complete', productUnitType: 'jars', vidalyticsEmbedId: 'as4PO4H7j9nMzpoe' }, ...baseRouteConfig },
  { path: 'US_6-Unit-MorningComplete_AP_240708', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete_AP_240708.json', productQuantity: 6, productName: 'Morning Complete', productUnitType: 'jars', vidalyticsEmbedId: 'as4PO4H7j9nMzpoe' }, ...baseRouteConfig },

  // Flora Complete 250522 / 240724
  { path: 'US_3-Unit-FloraComplete_AP_250522', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-FloraComplete_AP_250522.json', productQuantity: 3, productName: 'Flora Complete', productUnitType: 'bottles' }, ...baseRouteConfig },
  { path: 'US_6-Unit-FloraComplete_AP_250522', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-FloraComplete_AP_250522.json', productQuantity: 6, productName: 'Flora Complete', productUnitType: 'bottles' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-FloraComplete_AP_240724', data: ds1('Flora Complete', 'bottle', 'bottles', '../assets/page-configurations/downsells/DS_1-Unit-FloraComplete_AP_240724.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-FloraComplete_AP_240724', data: ds3('Flora Complete', 'bottles', 'bottles', '../assets/page-configurations/downsells/DS_1-Unit-FloraComplete_AP_240724.json'), ...baseRouteConfig },

  // Essential Skin Food (Morning Complete funnel) 210320
  { path: 'US_3-Unit-EssentialSkinFood-MC_AP_210320', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood-MC_AP_210320.json', productQuantity: 3, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-EssentialSkinFood-MC_AP_210320', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood-MC_AP_210320.json', productQuantity: 6, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-EssentialSkinFood_AP_210320', data: ds1('Essential Skin Food', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP_210320.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-EssentialSkinFood_AP_210320', data: ds3('Essential Skin Food', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP_210320.json'), ...baseRouteConfig },

  // Algae Omegas (Morning Complete funnel)
  { path: 'US_3-Unit-AlgaeOmegas-MC_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AlgaeOmegas-MC_AP.json', productQuantity: 3, productName: 'Algae Omegas', productUnitType: 'bottles' }, ...baseRouteConfig },
  { path: 'US_6-Unit-AlgaeOmegas-MC_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AlgaeOmegas-MC_AP.json', productQuantity: 6, productName: 'Algae Omegas', productUnitType: 'bottles' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-AlgaeOmegas_AP', data: ds1('Enhanced Algae Omegas', 'bottle', 'bottles', '../assets/page-configurations/downsells/DS_1-Unit-AlgaeOmegas_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-AlgaeOmegas_AP', data: ds3('Enhanced Algae Omegas', 'bottles', 'bottles', '../assets/page-configurations/downsells/DS_1-Unit-AlgaeOmegas_AP.json'), ...baseRouteConfig },

  // Morning Complete INT
  { path: 'US_3-Unit-MorningComplete_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete_AP_INT.json', productQuantity: 3, productName: 'Morning Complete', productUnitType: 'jars', vidalyticsEmbedId: 'as4PO4H7j9nMzpoe' }, ...baseRouteConfig },
  { path: 'US_6-Unit-MorningComplete_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningComplete_AP_INT.json', productQuantity: 6, productName: 'Morning Complete', productUnitType: 'jars', vidalyticsEmbedId: 'as4PO4H7j9nMzpoe' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-MorningComplete_AP_INT', data: ds1('Morning Complete', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MorningComplete_AP_INT.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-MorningComplete_AP_INT', data: ds3('Morning Complete', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MorningComplete_AP_INT.json'), ...baseRouteConfig },

  // Morning Complete Travel Packs
  { path: 'US_3-Unit-MorningCompletePack_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningCompletePack_AP.json', productQuantity: 3, productName: 'Morning Complete', productUnitType: 'packs' }, ...baseRouteConfig },
  { path: 'US_6-Unit-MorningCompletePack_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MorningCompletePack_AP.json', productQuantity: 6, productName: 'Morning Complete', productUnitType: 'packs' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-MorningCompletePack_AP', data: ds1('Morning Complete', 'pack', 'packs', '../assets/page-configurations/downsells/DS_1-Unit-MorningCompletePack_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-MorningCompletePack_AP', data: ds3('Morning Complete', 'packs', 'packs', '../assets/page-configurations/downsells/DS_1-Unit-MorningCompletePack_AP.json'), ...baseRouteConfig },

  // GI Prime Vegan (Morning Complete funnel)
  { path: 'US_3-Unit-GIPrimeVegan-MC_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-GIPrimeVegan-MC_AP.json', productQuantity: 3, productName: 'GI Prime', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-GIPrimeVegan-MC_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-GIPrimeVegan-MC_AP.json', productQuantity: 6, productName: 'GI Prime', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-GIPrimeVegan_AP', data: ds1('GI Prime', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-GIPrimeVegan_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-GIPrimeVegan_AP', data: ds3('GI Prime', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-GIPrimeVegan_AP.json'), ...baseRouteConfig },

  // Essential Skin Food (Morning Complete funnel) INT
  { path: 'US_3-Unit-EssentialSkinFood-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood-MC_AP_INT.json', productQuantity: 3, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-EssentialSkinFood-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-EssentialSkinFood-MC_AP_INT.json', productQuantity: 6, productName: 'Essential Skin Food', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-EssentialSkinFood_AP_INT', data: ds1('Essential Skin Food', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP_INT.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-EssentialSkinFood_AP_INT', data: ds3('Essential Skin Food', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-EssentialSkinFood_AP_INT.json'), ...baseRouteConfig },

  // Mito Vitality (Morning Complete funnel) INT
  { path: 'US_3-Unit-MitoVitality-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MitoVitality-MC_AP_INT.json', productQuantity: 3, productName: 'Mito Vitality', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-MitoVitality-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MitoVitality-MC_AP_INT.json', productQuantity: 6, productName: 'Mito Vitality', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-MitoVitality_AP_INT', data: ds1('Mito Vitality', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MitoVitality_AP_INT.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-MitoVitality_AP_INT', data: ds3('Mito Vitality', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-MitoVitality_AP_INT.json'), ...baseRouteConfig },

  // Algae Omegas (Morning Complete funnel) INT
  { path: 'US_3-Unit-AlgaeOmegas-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AlgaeOmegas-MC_AP_INT.json', productQuantity: 3, productName: 'Algae Omegas', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-AlgaeOmegas-MC_AP_INT', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AlgaeOmegas-MC_AP_INT.json', productQuantity: 6, productName: 'Algae Omegas', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-AlgaeOmegas_AP_INT', data: ds1('Enhanced Algae Omegas', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-AlgaeOmegas_AP_INT.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-AlgaeOmegas_AP_INT', data: ds3('Enhanced Algae Omegas', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-AlgaeOmegas_AP_INT.json'), ...baseRouteConfig },

  // Vital Strength (Essential Skin Food funnel)
  { path: 'US_3-Unit-VitalStrength-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-VitalStrength-EssentialSkinFood_AP.json', productQuantity: 3, productName: 'Vital Strength', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-VitalStrength-EssentialSkinFood_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-VitalStrength-EssentialSkinFood_AP.json', productQuantity: 6, productName: 'Vital Strength', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'DS_1-Unit-VitalStrength_AP', data: ds1('Vital Strength', 'jar', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-VitalStrength_AP.json'), ...baseRouteConfig },
  { path: 'DS_3-Unit-VitalStrength_AP', data: ds3('Vital Strength', 'jars', 'jars', '../assets/page-configurations/downsells/DS_1-Unit-VitalStrength_AP.json'), ...baseRouteConfig },

  // BioCollagen Complex (Morning Complete funnel) - DEV-56433
  { path: 'US_3-Unit-BioCollagenComplex-MorningComplete_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BioCollagenComplex-MorningComplete_AP.json', productQuantity: 3, productName: 'BioCollagen Complex', productUnitType: 'jars' }, ...baseRouteConfig },
  { path: 'US_6-Unit-BioCollagenComplex-MorningComplete_AP', data: { pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BioCollagenComplex-MorningComplete_AP.json', productQuantity: 6, productName: 'BioCollagen Complex', productUnitType: 'jars' }, ...baseRouteConfig },

];

class CustomReuseStrategy extends RouteReuseStrategy {
  /**
   * Determines if a route should be detached and stored for potential reuse.
   * Returns false as we don't store routes.
   */
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Stores a detached route (not used in this implementation).
   */
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // No-op: routes are not stored
  }

  /**
   * Determines if a stored route should be attached.
   * Returns false as we don't store routes.
   */
  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Retrieves a stored route (not used in this implementation).
   */
  retrieve(_route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    return null;
  }

  /**
   * Determines whether to reuse a route when navigating.
   * On iOS devices, routes are never reused to maintain compatibility
   *
   * @param future The route being navigated to
   * @param curr The current route
   * @returns true if the route should be reused, false otherwise
   */
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    // Check if iOS with safe fallback for SSR/testing environments
    const isIOS = this.detectIOSDevice();

    if (isIOS) {
      return false; // Never reuse on iOS
    }

    // Default Angular behavior: reuse if route configs are identical
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * Detects if the current device is an iOS device.
   * Returns false if navigator is unavailable (SSR/testing).
   */
  private detectIOSDevice(): boolean {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false; // Safe fallback for SSR
    }

    // Check for iPhone, iPad, or iPod in user agent
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }]
})
export class AppRoutingModule {
  constructor(public router: Router) {
    console.log("[GH] AppRoutingModule constructor " + document.location.origin + '/assets/html/a18tests.html');
    let content = {};
    let logic = (content: any) => {
      if (Object.keys(content).length === 0) {
        console.log("[GH] Error getting upsell dynamic content");
        this.routeHandlerFinally();
        return;
      } else {
        console.log("[GH] Got upsell dynamic content", content);
      }
      for (let prop in content) {
        if (prop == "fileListStream") {
          for (const key in (content as any)[prop]) {
            if ((content as any)[prop].hasOwnProperty(key)) {
              /*  console.log(
                 `[GH] push this key? ${key}`,
                 (content as any)[prop][key]
               ); */
              //console.log('this.router.config', ...this.router.config);

              let alreayAdded = false;
              for (let i = 0; i < this.router.config.length; i++) {
                if (this.router.config[i].path == (content as any)[prop][key].url) {
                  //console.log('route already added ' + (content as any)[prop][key].url);
                  alreayAdded = true;
                  break;
                }
              }
              if (alreayAdded) {
                continue;
              }

              if (typeof (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent == 'object') {
                let isvalid = false;
                for (let i = 0; i < (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent.length; i++) {
                  //console.log('checking '+(content as any)[prop][key].url, (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i])
                  if ((window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i] == 'upDownDyn-' + (content as any)[prop][key].url + '.json') {
                    isvalid = true;
                    break;
                  }
                }
                if (!isvalid) {
                  continue;
                }
                this.router.config.push({
                  path: (content as any)[prop][key].url,
                  component: UpsellDynamic,
                  data: { animation: "enterLeavePage" },
                });
              } else {
                console.log('upsellDynamicCMSControl.dynamicPageNamesWithContent is not an array');
              }
            }
          }
        }
      }
      this.routeHandlerFinally();
    }
    if ((window as any)['upsellDynamicContent']) {
      logic((window as any)['upsellDynamicContent']);
      return;
    }
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "/assets/content/store_dynamic_upsell_control.json", false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = () => {
      if (typeof xhr.response == "string") content = JSON.parse(xhr.response);
      else if (typeof xhr.response == "object") content = xhr.response;
      logic(content);
    };
    xhr.onerror = (error) => {
      console.log(`XHR Error: ${error}`);
      this.routeHandlerFinally();
    };

    xhr.send();
  }

  routeHandlerFinally() {
    // Wildcard route TODO add a not found handler
    this.router.config.push({
      path: "**",
      component: OopsComponent,
      data: { animation: "enterLeavePage" },
    });
  }
}
